module.exports = __webpack_public_path__ + "img/zgc.2cb537e4.png";